import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthAdminService } from 'src/app/core/auth/service/auth-admin.service';

import { BaseForgotPasswordComponent } from '../../base-forgot-password.component';
import { LayoutUtilsService } from './../../../../core/_base/crud/utils/layout-utils.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent
  extends BaseForgotPasswordComponent
  implements OnInit, OnDestroy
{
  constructor(
    protected authService: AuthAdminService,
    protected fb: FormBuilder,
    protected cdr: ChangeDetectorRef,
    protected router: Router,
    protected layoutUtilsService: LayoutUtilsService,
    protected route: ActivatedRoute,
  ) {
    super();
  }
}
